import React from 'react';
import { FaStar } from 'react-icons/fa';
import { motion } from 'framer-motion';
import './RatingDistribution.css';

const RatingDistribution = ({ distribution, total }) => {
  return (
    <div className="rating-distribution">
      <h5>Rating Distribution</h5>
      {[5, 4, 3, 2, 1].map(rating => {
        const count = distribution[rating] || 0;
        const percentage = total > 0 ? (count / total) * 100 : 0;
        
        return (
          <div key={rating} className="rating-bar-container">
            <div className="rating-label">
              <span className="star-count">{rating}</span>
              <FaStar className="star-icon" />
            </div>
            <div className="progress-container">
              <motion.div
                className="progress-bar"
                initial={{ width: 0 }}
                animate={{ width: `${percentage}%` }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              />
            </div>
            <div className="rating-count">
              {count}
              <span className="rating-percentage">
                ({percentage.toFixed(1)}%)
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RatingDistribution; 